module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('SitePage_FreeHostedVideos', {
		activate: function (params) {
			this.callParent('activate', arguments);

			var isMixed = this.getAlias() === 'freeHostedMixed';

			if (this.isRun()) {
				if (isMixed) {
					this.rwom1('#fhv #photoList').load(params.id);
				}

				return this.rwom1('#fhv').setFreeHostedContentId(params.id);
			}

			return this.wait('running').then(function () {
				if (isMixed) {
					this.rwom1('#fhv #photoList').load(params.id);
				}

				return this.rwom1('#fhv').setFreeHostedContentId(params.id);
			}.bind(this));
		}
	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/freeHostedVideos.js
// module id = 917
// module chunks = 4